import { DotCMSBasicContentlet } from '@dotcms/types';
import { sortBy } from 'lodash-es';

export class CustomDotCmsUveContentletHelper {
  static getSortedSubContentlets(
    contentlet: DotCMSBasicContentlet,
    subContentletKeys?: string[],
    key?: keyof DotCMSBasicContentlet
  ): DotCMSBasicContentlet[] {
    let contents: DotCMSBasicContentlet[] = [];
    Object.entries(contentlet).forEach(([keys, values]) => {
      if (subContentletKeys.includes(keys)) {
        contents = [...contents, ...values];
      }
    });

    contents = [
      ...sortBy(
        contents.filter(e => e[key] !== undefined && e[key] !== 0),
        e => e[key]
      ),
      ...contents.filter(e => !e[key]),
    ];
    return contents;
  }
}
